import { mainApi } from '../../../../api/mainApi';
import { middlewareApi } from '../../../middleware/middlewareApi';
import {
  ClassroomEdLvl,
  ClassroomEdLvlByPeriodResponse,
  ClassroomEdLvlPayload,
  ClassroomEdLvlResponse,
} from '../interfaces/classroomEdLvl.interface';

export const classroomEdLvlTags = middlewareApi.enhanceEndpoints({
  addTagTypes: ['ClassroomEdLvl', 'ClassroomsSelected'],
});
// Define a service using a base URL and expected endpoints
export const classroomEdLvlApi = classroomEdLvlTags.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * @GET all Classrooms by campus, education level and period
     */
    getClassroomsFiltered: builder.query<
      ClassroomEdLvlResponse,
      {
        profileId: number;
        campusId: number;
        periodId: number;
        educationLvl: number;
        classroomStatus: string | null; //Filter
        classroomTypeId: number | null; //filter
        page: number;
        sort?: string;
        perPage: number; //size
        type_sort?: string;
        search: string;
        statusId?: number;
      }
    >({
      queryFn: async ({
        profileId,
        periodId,
        campusId,
        educationLvl,
        classroomStatus = null,
        classroomTypeId = null,
        page,
        sort = 'id',
        perPage, //size
        type_sort = 'desc',
        search,
        statusId,
      }) => {
        try {
          const { data } = await mainApi.get<ClassroomEdLvlResponse>(
            `campus/${campusId}/classrooms`,
            {
              params: {
                user_profile_id: profileId,
                period_id: periodId,
                education_level_id: educationLvl,
                page,
                size: perPage,
                sort,
                type_sort,
                classroom_status: classroomStatus,
                ...(classroomTypeId && { classroom_type_id: classroomTypeId }),
                search,
                ...(statusId && { status_id: statusId }),
              },
            }
          );

          // const dataAll = data;

          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      providesTags: (result) =>
        result
          ? [
              ...result.data.map(({ id }) => ({ type: 'ClassroomEdLvl', id } as const)),
              { type: 'ClassroomEdLvl', id: 'LIST' },
            ]
          : [{ type: 'ClassroomEdLvl', id: 'LIST' }],
    }),

    /**
     * @GET all ClassroomEdLvl By period (deprecated)
     */
    // getClassroomEdLvls: builder.query<ClassroomEdLvl[], { profileId: number; periodId: number }>({
    //   queryFn: async ({ profileId, periodId }, { dispatch }) => {
    //     try {
    //       const { data } = await mainApi.get<ClassroomEdLvlResponse>(
    //         `periods/${periodId}/classroom-education-levels`,
    //         {
    //           params: {
    //             user_profile_id: profileId,
    //           },
    //         }
    //       );

    //       const dataAll = data.data;

    //       return { data: dataAll };
    //     } catch (error: any) {
    //       return { error };
    //     }
    //   },
    //   providesTags: (result) =>
    //     result
    //       ? [
    //           ...result.map(({ id }) => ({ type: 'ClassroomEdLvl', id } as const)),
    //           { type: 'ClassroomEdLvl', id: 'LIST' },
    //         ]
    //       : [{ type: 'ClassroomEdLvl', id: 'LIST' }],
    // }),

    /**
     * @GET all selected classrooms by periods id and education level
     */
    getClassroomsByPeriodEdlevel: builder.query<
      ClassroomEdLvlByPeriodResponse,
      {
        profileId: number;
        page: number;
        perPage: number;
        search: string;
        sort?: string;
        order: string;
        periodId: number;
        edLvlId: number;
        campusId: number;
        filter?: number;
      }
    >({
      queryFn: async ({
        profileId,
        page,
        search,
        perPage,
        sort,
        order,
        periodId,
        edLvlId,
        campusId,
        filter,
      }) => {
        try {
          const { data } = await mainApi.get<ClassroomEdLvlByPeriodResponse>(
            `/classroom-education-levels/periods/${periodId}/education_levels/${edLvlId}`,
            {
              params: {
                campus: campusId,
                user_profile_id: profileId,
                ...(filter === 0 && { filter: 0 }),
                // filter: 0,
                page,
                size: perPage,
                sort: sort,
                type_sort: order,
                search,
              },
            }
          );

          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      providesTags: (result) =>
        result
          ? [
              ...result.data.map(({ id }) => ({ type: 'ClassroomsSelected', id } as const)),
              { type: 'ClassroomsSelected', id: 'CL_LIST' },
            ]
          : [{ type: 'ClassroomsSelected', id: 'CL_LIST' }],
    }),

    getAllClassroomsByPeriodEdlevel: builder.query<
      ClassroomEdLvl[],
      {
        profileId: number;
        periodId: number;
        edLvlId: number;
        campusId: number;
        filterCampus?: boolean;
        typeSubjectId?: number;
        loans?: boolean;
        offer_id?: number;
      }
    >({
      queryFn: async ({
        profileId,

        periodId,
        edLvlId,
        campusId,
        filterCampus,
        typeSubjectId,
        loans,
        offer_id,
      }) => {
        try {
          const { data } = await mainApi.get<ClassroomEdLvl[]>(
            `/classroom-education-levels/periods/${periodId}/education_levels/${edLvlId}`,
            {
              params: {
                campus: campusId,
                user_profile_id: profileId,
                data: filterCampus ? 'filter' : 'all',
                type_subject_id: typeSubjectId,
                loans,
                offer_id,
              },
            }
          );

          return { data: Array.isArray(data) ? data : [] };
        } catch (error: any) {
          return { error };
        }
      },
      providesTags: [
        {
          type: 'ClassroomPeriodEdLvl',
          id: 'LIST',
        },
      ],
    }),

    /**
     * @GET ClassroomEdLvl by id
     */
    getClassroomEdLvl: builder.query<
      ClassroomEdLvl,
      { profileId: number; classroomEdLvlId: number }
    >({
      queryFn: async ({ profileId, classroomEdLvlId }) => {
        try {
          const { data } = await mainApi.get<ClassroomEdLvl>(
            `/classroom-education-levels/${classroomEdLvlId}`,
            {
              params: {
                user_profile_id: profileId,
              },
            }
          );

          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      providesTags: (result, error, { profileId }) => [{ type: 'ClassroomEdLvl', profileId }],
    }),

    /**
     * @POST create ClassroomEdLvl
     */
    addClassroomEdLvl: builder.mutation<
      ClassroomEdLvl,
      { profileId: number; classroomEdLvlPayload: Partial<ClassroomEdLvlPayload> }
    >({
      queryFn: async ({ profileId, classroomEdLvlPayload }) => {
        try {
          const { data } = await mainApi.post<ClassroomEdLvl>('/classroom-education-levels', {
            user_profile_id: profileId,
            ...classroomEdLvlPayload,
          });
          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      invalidatesTags: [
        { type: 'ClassroomEdLvl', id: 'LIST' },
        { type: 'ClassroomsSelected', id: 'CL_LIST' },
        {
          type: 'ClassroomPeriodEdLvl',
          id: 'LIST',
        },
        {
          type: 'ClassroomPeriodEdLvl',
          id: 'LIST',
        },
        { type: 'ClassroomsSelected', id: 'CL_LIST' },
      ],
    }),

    /**
     * @PUT update ClassroomEdLvl
     */
    updateClassroomEdLvl: builder.mutation<
      ClassroomEdLvl,
      {
        profileId: number;
        classroomEdLvlId: number;
        classroomEdLvlPayload: Partial<ClassroomEdLvl>;
      }
    >({
      queryFn: async ({ profileId, classroomEdLvlId, classroomEdLvlPayload }) => {
        try {
          const { data } = await mainApi.put<ClassroomEdLvl>(
            `/classroom-education-levels/${classroomEdLvlId}`,
            {
              user_profile_id: profileId,
              ...classroomEdLvlPayload,
            }
          );

          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      invalidatesTags: [
        { type: 'ClassroomEdLvl', id: 'LIST' },
        { type: 'ClassroomsSelected', id: 'CL_LIST' },
        {
          type: 'ClassroomPeriodEdLvl',
          id: 'LIST',
        },
        {
          type: 'ClassroomPeriodEdLvl',
          id: 'LIST',
        },
        { type: 'ClassroomsSelected', id: 'CL_LIST' },
      ],
    }),

    /**
     * @DELETE remove ClassroomEdLvl
     */
    deleteClassroomEdLvl: builder.mutation<
      ClassroomEdLvl,
      { profileId: number; classroomEdLvlId: number }
    >({
      queryFn: async ({ profileId, classroomEdLvlId }) => {
        try {
          const { data } = await mainApi.delete(`classroom-education-levels/${classroomEdLvlId}`, {
            data: {
              user_profile_id: profileId,
            },
          });

          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      invalidatesTags: [
        { type: 'ClassroomEdLvl', id: 'LIST' },
        { type: 'ClassroomsSelected', id: 'CL_LIST' },
      ],
    }),

    //
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetClassroomsFilteredQuery,
  useGetClassroomEdLvlQuery,
  useAddClassroomEdLvlMutation,
  useDeleteClassroomEdLvlMutation,
  useUpdateClassroomEdLvlMutation,
  useGetClassroomsByPeriodEdlevelQuery,
  useGetAllClassroomsByPeriodEdlevelQuery,
} = classroomEdLvlApi;
